import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { navGroups } from 'components/navbar/navGroups';

// import { FaInstagram, FaLinkedin, FaYoutube, FaTiktok } from 'react-icons/fa';

export const Footer = () => {
  const youtubeSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/youtube.png`;
  const tiktokSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/tiktok.png`;
  const linkedinSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/linkedin.png`;
  const instagramSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/instagram.png`;
  // const emailSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/web.png`;
  const redditSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/reddit.png`;
  const logoTextSrc = `${process.env.PUBLIC_URL}/assets/toastie-text.svg`;

  const appStoreLink = 'https://apps.apple.com/au/app/toastie-health-tracker/id6736644572';
  const appStoreSrc = `${process.env.PUBLIC_URL}/assets/appDownload/AppStore.png`;

  const playStoreLink = 'https://play.google.com/store/apps/details?id=au.toastie.health.tracker&hl=en_AU&pli=1';
  const playStoreSrc = `${process.env.PUBLIC_URL}/assets/appDownload/PlayStore.png`;

  return (
    <footer className="footer-container">
      <div className="footer-grid-wrapper">
        <div className="company-info-section">
          <div className="logo-link">
            <div className="logo-icon-wrapper">
              <img id="footer-logo-text" src={logoTextSrc} alt="Toastie" />
            </div>
          </div>
          <div className="footer-download-buttons">
              <a href={appStoreLink} target="_blank" rel="noopener noreferrer">
                <img 
                  src={appStoreSrc}
                  alt="Download on the App Store"
                  className="download-button"
                />
              </a>
              <a href={playStoreLink} target="_blank" rel="noopener noreferrer">
                <img 
                  src={playStoreSrc}
                  alt="Get it on Google Play"
                  className="download-button"
                />
              </a>
            </div>
          <p className="copyright-text">&copy; 2026 Toastie Health. Made with ♥️</p>
          <p className="footer-legal">
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <span aria-hidden="true"> · </span>
            <Link to="/terms-of-use" className="footer-link">Terms of Use</Link>
          </p>
        </div>

        {navGroups.map((group) => (
          <div key={group.id} className="links-section">
            <h3 className="section-title">{group.label}</h3>
            <ul className="links-list">
              {group.items.map((item) => (
                <li key={item.label}>
                  {item.external ? (
                    <a href={item.to} target="_blank" rel="noopener noreferrer" className="footer-link">{item.label}</a>
                  ) : (
                    <Link to={item.to} className="footer-link">{item.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Social Media & Contact */}
        <div className="social-contact-section">
          <h3 className="section-title">Connect</h3>
          <div className="footer-socials">
            <a href="https://tiktok.com/@toastiehealth" target="_blank" rel="noopener noreferrer">
              <img src={tiktokSrc} alt='tiktok' />
            </a>
            <a href="https://instagram.com/toastiehealth" target="_blank" rel="noopener noreferrer">
              <img src={instagramSrc} alt='Instagram' />
            </a>
            <a href="https://www.linkedin.com/company/toastie" target="_blank" rel="noopener noreferrer">
              <img src={linkedinSrc} alt='linkedin' />
            </a>
            <a href="https://www.youtube.com/@toastiehealth" target="_blank" rel="noopener noreferrer">
              <img src={youtubeSrc} alt='youtube' />
            </a>
            <a href="https://www.reddit.com/r/ToastieHealth/" target="_blank" rel="noopener noreferrer">
              <img src={redditSrc} alt='reddit' />
            </a>
          </div>
          <p className="contact-email"><a href="mailto:hello@toastie.au" className="footer-link email-link">hello@toastie.au</a></p>
        </div>
      </div>
    </footer>
  );
};
